export const isLoggedIn = user => user && !!user.get('token')
export const emailConfirmed = user => user && !!user.get('emailConfirmed', true)

export const userLoginAndEmailConfirmRequired = store => (nextState, replace) => {
  const user = store.getState().user
  if (!isLoggedIn(user)) {
    replace({
      pathname: '/login',
      state: {
        next: {
          pathname: nextState.location.pathname,
          query: nextState.location.query,
        },
      },
    })
  } else if (!emailConfirmed(user)) {
    replace({
      pathname: '/confirm-email',
      state: {
        next: {
          pathname: nextState.location.pathname,
          query: nextState.location.query,
        },
      },
    })
  }
}

export const adminLoginRequired = store => (nextState, replace) => {
  const user = store.getState().user
  if (user.get('isAdmin') === 'false') {
    replace({
      pathname: '/',
      state: {
        next: {
          pathname: nextState.location.pathname,
          query: nextState.location.query,
        },
      },
    })
  }
}

export const proPlanRequired = store => (nextState, replace) => {
  const user = store.getState().user
  if (!isLoggedIn(user)) {
    replace({
      pathname: '/login',
      state: {
        next: {
          pathname: nextState.location.pathname,
          query: nextState.location.query,
        },
      },
    })
  } else if (user.get('planType', 100) * 1 < 200) {
    replace({
      pathname: '/subscribe',
      state: {
        next: {
          pathname: nextState.location.pathname,
          query: nextState.location.query,
        },
      },
    })
  }
}

export const teamPlanRequired = store => (nextState, replace) => {
  const user = store.getState().user
  if (!isLoggedIn(user)) {
    replace({
      pathname: '/login',
      state: {
        next: {
          pathname: nextState.location.pathname,
          query: nextState.location.query,
        },
      },
    })
  } else if (user.get('planType', 100) * 1 < 300) {
    replace({
      pathname: '/subscribe',
      state: {
        next: {
          pathname: nextState.location.pathname,
          query: nextState.location.query,
        },
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/routes.js